import React, { useState } from 'react';
import { Collapse, Link, List, ListItemButton, ListItemIcon, ListItemText } from '@mui/material';
import { ExpandLess, ExpandMore } from '@mui/icons-material';
import SvgIcon from '@mui/material/SvgIcon/SvgIcon';

export interface SidebarItemProps {
    title: string;
    url?: string;
    pages?: SidebarItemProps[];
    icon?: typeof SvgIcon;
}

export interface DrawerProps {
    closeDrawer: () => void;
}

const SidebarItem: React.FC<SidebarItemProps & DrawerProps> = ({ title, url, pages, icon: Icon, closeDrawer }) => {
    const [listOpened, openList] = useState<boolean>(false);

    const onListToggle = () => {
        openList((prevState) => !prevState);
    };

    const handleClick = () => {
        if (pages?.length) {
            onListToggle();
        } else {
            closeDrawer();
        }
    };

    const hasNestedList = !!pages?.length;

    const linkProps = url
        ? {
              href: url,
              underline: 'none',
              component: Link,
              sx: {
                  '&.active': {
                      backgroundColor: 'common.primaryLightSelected',
                      fontSize: '32px',
                      '& .MuiTypography-root': {
                          fontWeight: '600',
                      },
                  },
              },
          }
        : {};

    const listItem = (
        <ListItemButton {...linkProps} onClick={handleClick}>
            {Icon && (
                <ListItemIcon>
                    <Icon sx={{ fontSize: '28px', color: 'common.black' }} />
                </ListItemIcon>
            )}

            <ListItemText primary={title} primaryTypographyProps={{ sx: { fontSize: '15px' } }} />

            {hasNestedList && (listOpened ? <ExpandLess /> : <ExpandMore />)}
        </ListItemButton>
    );

    return (
        <>
            {listItem}

            {hasNestedList && listOpened && (
                <Collapse in={listOpened} timeout='auto' unmountOnExit>
                    <List
                        sx={{
                            paddingLeft: '34px',
                            '& .MuiButtonBase-root': {
                                marginTop: '6px',
                            },
                        }}
                        component='div'
                        disablePadding
                    >
                        {pages?.map((page) => (
                            <SidebarItem {...page} key={page.title} closeDrawer={closeDrawer} />
                        ))}
                    </List>
                </Collapse>
            )}
        </>
    );
};

export default SidebarItem;
